// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Bgz4","footer":"ModalInfo_footer__MPGcy"};